import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import OwnershipTransferBlockData from '../../../Models/Content/OwnershipTransferBlockData';
import OwnershipTransfer from './OwnershipTransfer';

export default class OwnershipTransferBlock extends EpiComponent<OwnershipTransferBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <OwnershipTransfer iContent={this.props.data} />;
  }
}
